var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('CHeader',{attrs:{"hideMenu":_vm.hideMenu}}),_vm._v(" "),_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"0","min-width":"1400px"},attrs:{"src":_vm.iframesrc,"frameborder":"0"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84c7d4a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/chukou2021/index.vue
// module id = null
// module chunks = 